import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

function Stars({ value = 0 }) {
  const v = Math.round(Number(value) || 0);
  return (
    <span className="text-amber-600 font-mono text-xs">
      {"★".repeat(Math.max(0, Math.min(5, v)))}{"☆".repeat(5 - Math.max(0, Math.min(5, v)))}
    </span>
  );
}

export default function Suppliers() {
  return (
    <ResourcePage
      endpoint="/suppliers"
      testidPrefix="supplier"
      eyebrow="Stakeholders"
      title="Supplier Relationship"
      subtitle="Directory, scorecards, contracts, and performance evaluation."
      ctaLabel="Add supplier"
      fields={[
        { name: "name", label: "Supplier name", required: true },
        { name: "contact_person", label: "Contact person" },
        { name: "email", label: "Email" },
        { name: "phone", label: "Phone" },
        { name: "category", label: "Category", placeholder: "Beverages, Fresh produce, Logistics…" },
        { name: "country", label: "Country", default: "Uganda" },
        { name: "delivery_score", label: "Delivery (0-5)", type: "number" },
        { name: "quality_score", label: "Quality (0-5)", type: "number" },
        { name: "pricing_score", label: "Pricing (0-5)", type: "number" },
        { name: "responsiveness_score", label: "Responsiveness (0-5)", type: "number" },
        { name: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "name", label: "Supplier" },
        { key: "contact_person", label: "Contact" },
        { key: "category", label: "Category" },
        { key: "country", label: "Country" },
        { key: "delivery_score", label: "Delivery", render: (i) => <Stars value={i.delivery_score} /> },
        { key: "quality_score", label: "Quality", render: (i) => <Stars value={i.quality_score} /> },
        { key: "is_active", label: "Active", render: (i) => <Badge tone={i.is_active === false ? "gray" : "emerald"}>{i.is_active === false ? "Inactive" : "Active"}</Badge> },
      ]}
      searchKeys={["name", "category", "country", "contact_person", "email"]}
    />
  );
}
